


































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { AdminCMSModule } from '@/app/store/modules/adminCMS'

@Component({
  name: 'AdminCMS',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public searchInput = ''
  private selected = []
  public created() {
    AdminCMSModule.paginationParam.search = ''
    this.getData()
  }

  public get fields() {
    return AdminCMSModule.fields
  }

  public get getUserData() {
    return AdminCMSModule.AdminCMSData
  }

  public getData() {
    AdminCMSModule.getAdminCMSData()
  }

  public get isLoading() {
    return AdminCMSModule.isLoading
  }
  public get page() {
    return AdminCMSModule.Pages
  }
  public get limit() {
    return AdminCMSModule.Limit
  }

  private funcSearch(item) {
    AdminCMSModule.paginationParam.search = item
    this.getData()
  }

  private onPageNumChanged(limit: any) {
    AdminCMSModule.paginationParam.paging.limit = limit
    this.getData()
  }

  private funcFirstPage() {
    AdminCMSModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    AdminCMSModule.paginationParam.paging.page =
      AdminCMSModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    AdminCMSModule.paginationParam.paging.page =
      AdminCMSModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    AdminCMSModule.paginationParam.paging.page =
      (this.getUserData.pagination && this.getUserData.pagination.pageCount) ||
      0
    this.getData()
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
